import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'
import formatDate from '@/utils/formatDate'
import isArrayOfObjects from '../../utils/array'
import isObject from '../../utils/object'

export default {
  namespaced: true,
  actions: {
    async searchPromotions(context, params) {
      const response = await http.get(`gift/promotion/${requestUrlFunction(params)}`)

      return response
    },
    async getPromotion(context, id) {
      const response = await http.get(`gift/promotion/${id}`)

      return response
    },
    async createPromotion(context, { promotion, files }) {
      const blob = new Blob(
        [
          JSON.stringify({
            name: promotion.name,
            description: promotion.description,
            btnActionName: promotion.btnActionName,
            sources: isArrayOfObjects(promotion.sources)
              ? promotion.sources.map((e) => e.name)
              : promotion.sources,
            startAt: formatDate(promotion.startAt),
            endAt: formatDate(promotion.endAt),
            enabled: promotion.enabled,
            showIn: promotion.showIn,
            giftId:
              Array.isArray(promotion.giftId) || promotion.giftId == null ? null : promotion.giftId,
            formType: isObject(promotion.formType) ? promotion.formType.name : promotion.formType,
          }),
        ],
        {
          type: 'application/json',
        }
      )

      const formData = new FormData()
      formData.append('promotion', blob)
      formData.append('file', files[0])

      const response = await http.post(`gift/promotion`, formData)

      return response
    },
    async updatePromotion(context, { promotion, files }) {
      const blob = new Blob(
        [
          JSON.stringify({
            name: promotion.name,
            description: promotion.description,
            btnActionName: promotion.btnActionName,
            sources: isArrayOfObjects(promotion.sources)
              ? promotion.sources.map((e) => e.name)
              : promotion.sources,
            startAt: formatDate(promotion.startAt),
            endAt: formatDate(promotion.endAt),
            enabled: promotion.enabled,
            showIn: promotion.showIn,
            giftId:
              Array.isArray(promotion.giftId) || promotion.giftId == null ? null : promotion.giftId,
            formType: isObject(promotion.formType) ? promotion.formType.name : promotion.formType,
          }),
        ],
        {
          type: 'application/json',
        }
      )

      const formData = new FormData()
      formData.append('promotion', blob)
      if (files) {
        formData.append('file', files[0])
      }

      const response = await http.put(`gift/promotion/${promotion.id}`, formData)

      return response
    },
    async deletePromotion(context, id) {
      const response = await http.delete(`gift/promotion/${id}`)

      return response
    },
  },
}
